export enum PSSRStatus {
  Draft = 1,
  Initiated = 2,
  InProgress = 3,
  Completed = 4,
  PendingApproval = 5,
  Approved = 6,
  Closed = 7,
  Cancel = 8,
}
